export const SCENIC_IDS = ["harbour"] as const;
export type ScenicId = (typeof SCENIC_IDS)[number];

export const SCENIC_META: Record<ScenicId, { name: string; blurb: string }> = {
  harbour: {
    name: "Harbour",
    blurb: "A dock and boat on the village river. Scenic for now — ready for a travel bot later.",
  },
};

export function isScenicId(id: string): id is ScenicId {
  return (SCENIC_IDS as readonly string[]).includes(id);
}
